import { Vector } from "./Vector";

export abstract class TrajectorySegment {
    centralBody: number;
    startTime: number;
    endTime: number;
    timeStep: number;
    
    constructor(data:any) {
        this.centralBody = data.centralBody;
        this.startTime = data.startTime;
        this.endTime = data.endTime;
        this.timeStep = data.timeStep;
    }

    abstract getPos(time: number): Vector; 
}


// WEBPACK FOOTER //
// ./src/TrajectorySegment.ts